'use client';

import { AnalyticsProvider as CardsAnalyticsProvider } from '@nerdwallet-cards/analytics';
import { PropsWithChildren } from 'react';
import {
  SEGMENT_DEPLOYABLE_NAME,
  SEGMENT_DEPLOYABLE_VERSION,
} from 'src/utils/analytics/constants';

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  return (
    <CardsAnalyticsProvider
      deployableName={`${SEGMENT_DEPLOYABLE_NAME}`}
      deployableVersion={SEGMENT_DEPLOYABLE_VERSION}
      writeKey={process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}
    >
      {children}
    </CardsAnalyticsProvider>
  );
};
